export default __webpack_public_path__ + "static/media/landing.ddeb42c4.jpg";